import { Typography, styled } from "@mui/material";
import { calendarNavigatorName } from "../classes.js";
const Label = styled(Typography, {
  name: calendarNavigatorName,
  slot: "Label",
  overridesResolver: (_, styles) => [styles.label]
})(() => ({
  flexGrow: 1,
  textAlign: "center"
}));
export {
  Label
};
//# sourceMappingURL=Label.js.map
